export default __webpack_public_path__ + "static/media/regulatory--no-motor-vehicles--g4.5e81bd00.png";